import requester from '@/services/requester'
import env from '@/.env.js'

const BACKEND_API_V1_URL = env.endpoint_backend

export default {
    //Get user/client tax address
    retrieve(parameters) {
        return requester.post(`${BACKEND_API_V1_URL}/taxaddresses`, parameters)
    },

    update(parameters) {
        return requester.put(`${BACKEND_API_V1_URL}/taxaddresses`, parameters)
    },

    create(parameters) {
        return requester.post(`${BACKEND_API_V1_URL}/taxaddresses/create`, parameters)
    },

    delete(parameters) {
        return requester.put(`${BACKEND_API_V1_URL}/taxaddresses/delete`, parameters)
    },

    restore(parameters) {
        return requester.put(`${BACKEND_API_V1_URL}/taxaddresses/restore`, parameters)
    },

}